import type { NodeData } from '@ipfabric/utils';

export const isNodeWalkable = (
  nodeData: NodeData,
): nodeData is NodeData & { path: string } =>
  nodeData.type === 'cloud' &&
  typeof nodeData.path === 'string' &&
  nodeData.path !== '';
